<template>
    <div class="mt-2" :class="size">
        <div :class="`card background--card ${modifiers}${newLayout ? ' card-new' : ''}`">
            <div
                class="card-header"
                v-if="!hideHeader"
            >
                <slot name="card-header"></slot>
            </div>
            <div
                class="card-body"
                :class="hasScroll"
                v-if="!hideBody"
            >
                <slot name="card-body"></slot>
            </div>
            <div 
                class="card-footer" 
                v-if="!hideFooter"
            >
                <slot name="card-footer"></slot>
            </div>
        </div>
        <slot name="card-extra"></slot>
    </div>
</template>


<script>
import initScrollbar from '@H/addScrollbar';
import { isDesktop } from '@H/device_helpers';

export default {
    name: 'Card',
    mounted() {
        if (!this.hideBody && this.newLayout) {
            this.$nextTick(() => {
                initScrollbar();
            });
        }
    },
    computed: {
        hasScroll() {
            return this.newLayout && isDesktop() ? 'perfect-scrollbar' : '';
        }
    },
    props: {
        size: {
            type: String,
            default: 'col-md-8'
        },
        newLayout: {
            type: Boolean,
            default: false
        },
        modifiers: {
            type: String,
            default: ''
        },
        hideHeader: {
            type: Boolean,
            default: false
        },
        hideBody: {
            type: Boolean,
            default: false
        },
        hideFooter: {
            type: Boolean,
            default: true
        }
    }
};
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/Card.vue